var map = {
	"./add.svg": "./src/icon/svg/add.svg",
	"./add_circle_fill.svg": "./src/icon/svg/add_circle_fill.svg",
	"./answer.svg": "./src/icon/svg/answer.svg",
	"./answer2.svg": "./src/icon/svg/answer2.svg",
	"./answer_disabled.svg": "./src/icon/svg/answer_disabled.svg",
	"./arrow_bottom.svg": "./src/icon/svg/arrow_bottom.svg",
	"./arrow_right_line.svg": "./src/icon/svg/arrow_right_line.svg",
	"./attachment_line.svg": "./src/icon/svg/attachment_line.svg",
	"./attention_fill.svg": "./src/icon/svg/attention_fill.svg",
	"./back.svg": "./src/icon/svg/back.svg",
	"./back_2_line.svg": "./src/icon/svg/back_2_line.svg",
	"./back_line.svg": "./src/icon/svg/back_line.svg",
	"./calendar.svg": "./src/icon/svg/calendar.svg",
	"./cha.svg": "./src/icon/svg/cha.svg",
	"./check_circle_fill.svg": "./src/icon/svg/check_circle_fill.svg",
	"./check_circle_line.svg": "./src/icon/svg/check_circle_line.svg",
	"./check_fill.svg": "./src/icon/svg/check_fill.svg",
	"./check_line.svg": "./src/icon/svg/check_line.svg",
	"./close_circle_fill.svg": "./src/icon/svg/close_circle_fill.svg",
	"./close_line.svg": "./src/icon/svg/close_line.svg",
	"./copy.svg": "./src/icon/svg/copy.svg",
	"./copy_2_line.svg": "./src/icon/svg/copy_2_line.svg",
	"./detail.svg": "./src/icon/svg/detail.svg",
	"./document_2_line.svg": "./src/icon/svg/document_2_line.svg",
	"./down.svg": "./src/icon/svg/down.svg",
	"./down_line.svg": "./src/icon/svg/down_line.svg",
	"./down_line2.svg": "./src/icon/svg/down_line2.svg",
	"./down_work.svg": "./src/icon/svg/down_work.svg",
	"./download_2_line.svg": "./src/icon/svg/download_2_line.svg",
	"./dui.svg": "./src/icon/svg/dui.svg",
	"./edit.svg": "./src/icon/svg/edit.svg",
	"./edit_2_line.svg": "./src/icon/svg/edit_2_line.svg",
	"./email.svg": "./src/icon/svg/email.svg",
	"./error_fill.svg": "./src/icon/svg/error_fill.svg",
	"./excel.svg": "./src/icon/svg/excel.svg",
	"./exit_door_line.svg": "./src/icon/svg/exit_door_line.svg",
	"./external_link_line.svg": "./src/icon/svg/external_link_line.svg",
	"./external_link_line2.svg": "./src/icon/svg/external_link_line2.svg",
	"./eye_2_line.svg": "./src/icon/svg/eye_2_line.svg",
	"./eye_close_line.svg": "./src/icon/svg/eye_close_line.svg",
	"./file_new_line.svg": "./src/icon/svg/file_new_line.svg",
	"./item.svg": "./src/icon/svg/item.svg",
	"./left_line.svg": "./src/icon/svg/left_line.svg",
	"./left_line_84.svg": "./src/icon/svg/left_line_84.svg",
	"./mail_send_line.svg": "./src/icon/svg/mail_send_line.svg",
	"./make.svg": "./src/icon/svg/make.svg",
	"./menu_line.svg": "./src/icon/svg/menu_line.svg",
	"./menu_name.svg": "./src/icon/svg/menu_name.svg",
	"./modal.svg": "./src/icon/svg/modal.svg",
	"./more_2_line.svg": "./src/icon/svg/more_2_line.svg",
	"./move_line.svg": "./src/icon/svg/move_line.svg",
	"./paper_line.svg": "./src/icon/svg/paper_line.svg",
	"./question_line.svg": "./src/icon/svg/question_line.svg",
	"./refresh_2_line.svg": "./src/icon/svg/refresh_2_line.svg",
	"./right_line.svg": "./src/icon/svg/right_line.svg",
	"./right_line_84.svg": "./src/icon/svg/right_line_84.svg",
	"./round_line.svg": "./src/icon/svg/round_line.svg",
	"./search_2_line.svg": "./src/icon/svg/search_2_line.svg",
	"./sel.svg": "./src/icon/svg/sel.svg",
	"./select.svg": "./src/icon/svg/select.svg",
	"./select_work.svg": "./src/icon/svg/select_work.svg",
	"./settings_2_line.svg": "./src/icon/svg/settings_2_line.svg",
	"./sort_ascending_line.svg": "./src/icon/svg/sort_ascending_line.svg",
	"./sort_descending_line.svg": "./src/icon/svg/sort_descending_line.svg",
	"./svg1.svg": "./src/icon/svg/svg1.svg",
	"./svg2.svg": "./src/icon/svg/svg2.svg",
	"./svg3.svg": "./src/icon/svg/svg3.svg",
	"./time.svg": "./src/icon/svg/time.svg",
	"./tomooni_works.svg": "./src/icon/svg/tomooni_works.svg",
	"./transfer_3_line.svg": "./src/icon/svg/transfer_3_line.svg",
	"./tryangle_down.svg": "./src/icon/svg/tryangle_down.svg",
	"./tryangle_right.svg": "./src/icon/svg/tryangle_right.svg",
	"./tryangle_right1.svg": "./src/icon/svg/tryangle_right1.svg",
	"./up_line.svg": "./src/icon/svg/up_line.svg",
	"./upload.svg": "./src/icon/svg/upload.svg",
	"./upload_2_line.svg": "./src/icon/svg/upload_2_line.svg",
	"./user_4_fill.svg": "./src/icon/svg/user_4_fill.svg",
	"./vab.svg": "./src/icon/svg/vab.svg",
	"./vuejs-fill.svg": "./src/icon/svg/vuejs-fill.svg",
	"./warning_line.svg": "./src/icon/svg/warning_line.svg",
	"./xls_fill.svg": "./src/icon/svg/xls_fill.svg",
	"./yin.svg": "./src/icon/svg/yin.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icon/svg sync \\.svg$";